export default [
  {
    path: '/tariffs',
    name: 'tariffs',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Тарифы',
    },
    children: [
      {
        path: '',
        name: 'tariffs-list',
        component: () => import('@/views/tariffs/tariffs.vue'),
        meta: {},
      },
      {
        path: 'add',
        name: 'tariffs-add',
        component: () => import('@/views/tariffs/add.vue'),
        meta: {
          title: 'Добавить',
        },
      },
      {
        path: ':id(\\d+)/edit',
        name: 'tariffs-edit',
        props: true,
        component: () => import('@/views/tariffs/edit.vue'),
        meta: {
          title: 'Изменить',
        },
      },
    ],
  },
]
